import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, map } from 'lodash';
import PaymentTable from '../../../common/PaymentTable';
import Money from '../../../common/money';
import Icon, { GLYPHS } from '../../../common/icon';
import { taxBreakdownArray } from '../../sale/components/shapes';
import Tooltip from '../../../common/tooltip';
import MembershipDiscountTooltip from '../../memberships/MembershipDiscountTooltip';

const ChargeModalSummary = ({
  servicesAmount,
  productsAmount,
  taxAmount,
  discountAmount,
  promoAmount,
  amountOwed,
  removePayment,
  paymentMethods,
  taxBreakdown,
  membershipDiscountAmount,
  membershipDiscounts,
}) => (
  <PaymentTable className="u-mv">

    <PaymentTable.Row display-if={servicesAmount}>
      <PaymentTable.Cell>Services:</PaymentTable.Cell>
      <PaymentTable.Cell data-automation-id="text:amountServices">
        <Money>{servicesAmount}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    <PaymentTable.Row display-if={productsAmount}>
      <PaymentTable.Cell>Products:</PaymentTable.Cell>
      <PaymentTable.Cell data-automation-id="text:amountProducts">
        <Money>{productsAmount}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    <PaymentTable.Row display-if={taxAmount && taxBreakdown.length === 1}>
      <PaymentTable.Cell>Tax:</PaymentTable.Cell>
      <PaymentTable.Cell data-automation-id="text:amountTaxTotal">
        <Money>{taxAmount}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    {taxBreakdown.length > 1 && map(taxBreakdown, tax => (
      <PaymentTable.Row>
        <PaymentTable.Cell>{tax.name}:</PaymentTable.Cell>
        <PaymentTable.Cell>
          <Money>{tax.amount}</Money>
        </PaymentTable.Cell>
      </PaymentTable.Row>
    ))}

    <PaymentTable.Row display-if={discountAmount}>
      <PaymentTable.Cell>Discounts:</PaymentTable.Cell>
      <PaymentTable.Cell className="u-co-red" data-automation-id="text:amountDiscount">
        <Money>{discountAmount}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    <PaymentTable.Row display-if={membershipDiscountAmount}>
      <PaymentTable.Cell>
        Membership Discount:
        <Tooltip renderTooltip={() => <MembershipDiscountTooltip discounts={membershipDiscounts} />} />
      </PaymentTable.Cell>
      <PaymentTable.Cell className="u-co-red" data-automation-id="text:amountMembershipDiscount">
        <Money>{membershipDiscountAmount}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    <PaymentTable.Row display-if={promoAmount}>
      <PaymentTable.Cell>Promo:</PaymentTable.Cell>
      <PaymentTable.Cell className="u-co-red" data-automation-id="text:amountPromo">
        <Money>{promoAmount}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

    {!isEmpty(paymentMethods) && paymentMethods.map(item => (
      <PaymentTable.Row gray key={item.id}>
        <PaymentTable.Cell>
          {item.label}
        </PaymentTable.Cell>
        <PaymentTable.Cell className="u-pr0" data-automation-id={`text:amount${item.label.split(' ')[0]}`}>
          <Money>{item.amount}</Money>
          <button type="button" className="c-payment-table__remove" onClick={removePayment(item.id)}>
            <Icon glyph={GLYPHS.closeBtn} size="nano" />
          </button>
        </PaymentTable.Cell>
      </PaymentTable.Row>
    ))}

    <PaymentTable.Row className="u-type--bold">
      <PaymentTable.Cell>
        Total Due
      </PaymentTable.Cell>
      <PaymentTable.Cell data-automation-id="text:totalDue">
        <Money>{amountOwed}</Money>
      </PaymentTable.Cell>
    </PaymentTable.Row>

  </PaymentTable>
);
ChargeModalSummary.propTypes = {
  servicesAmount: PropTypes.number.isRequired,
  productsAmount: PropTypes.number.isRequired,
  taxAmount: PropTypes.number.isRequired,
  discountAmount: PropTypes.number.isRequired,
  promoAmount: PropTypes.number.isRequired,
  amountOwed: PropTypes.number.isRequired,
  paymentMethods: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      amount: PropTypes.number,
    }),
  ).isRequired,
  removePayment: PropTypes.func.isRequired,
  taxBreakdown: taxBreakdownArray,
  membershipDiscountAmount: PropTypes.number.isRequired,
  membershipDiscounts: PropTypes.array.isRequired,
};

ChargeModalSummary.defaultProps = {
  taxBreakdown: [],
};

export default ChargeModalSummary;
